/* src/app/components/tag/tag.component.scss */
.row {
  display: inline-block;
  height: 17px;
  width: 17px;
}
/*# sourceMappingURL=tag.component.css.map */
